import { render, staticRenderFns } from "./PaineilmalaitehuoltoView.vue?vue&type=template&id=5e06c1ed&scoped=true"
import script from "./PaineilmalaitehuoltoView.vue?vue&type=script&lang=js"
export * from "./PaineilmalaitehuoltoView.vue?vue&type=script&lang=js"
import style0 from "./PaineilmalaitehuoltoView.vue?vue&type=style&index=0&id=5e06c1ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06c1ed",
  null
  
)

export default component.exports